// File: OrderStepper.js
import React, { useEffect, useState } from 'react';
import { Container, Button, Card, Row, Col } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';

import { getImageUrl, handleCheckUserLogin } from '../../../../MIS/Global';
import { useNavigate, useParams } from 'react-router-dom';
import { useModal } from '../../../ConfirmationModal/ModalContext';
import {
  getAddons_submit,
  getCalc_submit,
  getDetailProduct_submit,
  getDetail_submit,  
  handleGetNormalSize_list,
  handleGetOrder_list,
  handleGetProduct,
  handleGetSettingGST,
  handleGetUser,    
  handleSubmit_product
} from '../OrderProcess/orderModel';
import { decrypt } from '../../../../MIS/encryption';
import DynamicEditableTable from './DynamicEditableTable';

const EditOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showModal } = useModal();
  const [sizeOptions, setSizeOptions] = useState([]);  
  const [user, setUser] = useState({});
  const [product, setProduct] = useState({});
  const [gstPercent, setGstPercent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [quotations, setQuotations] = useState([]);
  const [addonOptions, setAddonOptions] = useState([]);
  const [filter, setFilter] = useState({action:'product_size'});

  const data = {
    pid: user?.id,
    party_name: user?.ownerName,
    party_mob: user?.mob,
    party_state: user?.state,
    party_city: user?.city,
    party_pinCode: user?.postalCode,
    party_address: user?.address,
    quote_no:quotations?.[0]?.quote_no || "",    
    quote_status: quotations?.[0]?.quote_status || "Pending",
    sub_total: getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'sub' }),
    discount: 0,
    gst_percent: Number(gstPercent).toFixed(2),
    s_gst: getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'gst' }),
    c_gst: getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'gst' }),
    grand_total: getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'grand_total' }),
    paid_amount: 0,
    balance_amount: 0,
    login_id: user?.id,
    quote_type: 0,
    addons_total: getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'addon' }),
    item_image: product?.id,
    cloth_name: '-',
    cloth_rate: 0,
    details: getDetailProduct_submit({ sizeOptions, product,quotations}),
    addons: [],
    prints:[]
  };

  const columns = [
    { label: 'Size', key: 'sizename', width: '50%', editable: false, align: 'left' },
    { label: 'Price', key: 'ch_price', width: '25%', editable: false, type: 'number' },
    { label: 'Qty', key: 'qty', width: '25%', editable: true, type: 'number' },
  ];

  const onCellChange = (id, value) => {
    const updatedOptions = sizeOptions.map((item) =>
    item.id === id ? { ...item, 
      qty: value >= 0 ? value : 0 ,
      s_mrp:item.ch_mrp,
      s_rate:item.ch_price,
      s_amount:Number((value >= 0 ? value : 0) * item.ch_price).toFixed(2)
    } : item
    );
    setSizeOptions(updatedOptions)
  };

  useEffect(() => {
    const dataPara = decrypt(id);
    const parts = dataPara.split("-");
    if(sizeOptions?.length<=0){
      let data ={...filter,subid:parts?.[1]}
      handleGetNormalSize_list({data,setLoading,
         setSizeOptions,pid:parts?.[0] });
    }
  },[]);
  
  useEffect(() => {
    if(sizeOptions.length > 0 && quotations.length <= 0){
      const data = decrypt(id);
      const parts = data.split("-");
      if (parts?.[2]) {      
        let filter={page:1,limit:1,id:parts?.[2]}
        handleGetOrder_list({filter,setQuotations,setQuoteLoading})
      }
    }
  },[sizeOptions]);

  useEffect(() => {
     if(quotations?.length > 0){
      if(sizeOptions.length > 0){        
        const merged = sizeOptions?.map(tItem => {
          const match = quotations?.[0]?.details?.find(sItem => sItem.item_size === tItem.sizename);        
          return match
            ? { ...tItem, qty: match.item_qty,s_mrp:tItem.ch_mrp,
              s_rate:tItem.ch_price,
              s_amount:Number((match.item_qty) * tItem.ch_price).toFixed(2) }
            : {...tItem, qty: 0,s_mrp:0,s_rate:0,s_amount:0} // unchanged if no match
        });
        setSizeOptions(merged);
      }
     }
  },[quotations]);
  
  
  useEffect(() => {
    const isLogin = handleCheckUserLogin("userData", "id");
    if (isLogin <= 0) {
      navigate(`/`);
    } else {
      if (!user || Object.keys(user).length === 0) {
        handleGetUser({ id: isLogin, setUser });
      }
    }
  }, []);

  useEffect(() => {
    if (!product || Object.keys(product).length === 0) {
      const data = decrypt(id);
      const parts = data.split("-");
      handleGetProduct({ id: parts[0], setProduct });
    }
    if (gstPercent == null) {
      handleGetSettingGST({ setGstPercent });
    }
  }, []);

   
  return (
    <Container className="order-stepper-container mt-4">        
      <h4 className="mb-3 fw-semibold text-start">Order {quotations?.length > 0 ? `#: ${quotations?.[0]?.quote_no}`:''}</h4>
      <Row>
        {/* Product Info - Left on md+, top on mobile */}
        <Col xs={12} md={4} className="mb-4">
          <Card className="shadow-sm">
            <Card.Body>
              {product?.id ? (
                <>
                  <div className="text-center mb-3">                  
                    <img
                      src={getImageUrl(`/media/${product?.imgpath}`)|| '/no-image.jpg'}
                      alt={product?.productname || 'Product Image'}
                      className="img-fluid rounded"
                      style={{ maxHeight: '200px', objectFit: 'contain' }}
                    />
                  </div>
                  <h5 className="mb-2 text-center">{product?.productname || "Product Name"}</h5>
                  <p className="text-muted text-center small mb-3">Product Code: {product?.productcode}</p>

                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      Sub Total:
                      <span>₹{quotations?.length > 0 && getCalc_submit({ gstPercent, addonOptions:[], sizeOptions, isType: 'size' })  <= 0 
                      ? Number(Number(quotations?.[0]?.sub_total)-Number(quotations?.[0]?.addons_total)).toFixed(2)
                      : getCalc_submit({ gstPercent, addonOptions:[], sizeOptions, isType: 'size' })
                      }</span>
                    </li>                   
                    <li className="list-group-item d-flex justify-content-between align-items-center fw-bold">
                      Grand Total:
                      <span>₹{
                        quotations?.length > 0 && getCalc_submit({ gstPercent, addonOptions:[], sizeOptions, isType: 'grand_total'}) <= 0
                        ? Number(quotations?.[0]?.grand_total).toFixed(2)
                        : getCalc_submit({ gstPercent, addonOptions:[], sizeOptions, isType: 'grand_total'})}</span>
                    </li>
                  </ul>
                </>
              ) : (
                <p className="text-center text-muted">Loading product info...</p>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* Order Steps - Right on md+, bottom on mobile */}
        <Col xs={12} md={8}>
        {quoteLoading || loading ? (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
         ) : (
          <>
          <DynamicEditableTable
            columns={columns}
            data={sizeOptions}
            loading={loading}
            onCellChange={onCellChange}
          />
          <div className="d-flex justify-content-end mt-3">
              <Button type="button" size="sm" variant="primary" onClick={()=>{
                handleSubmit_product({sizeOptions,
                 showModal,setSubmitLoading,data,navigate,id:quotations?.[0]?.id || 0})
              }}>
                  {submitLoading  ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : "Submit"}
              </Button>
          </div>
          </>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default EditOrder;
